import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class IntegracaoService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'configuracao-integracao');
  }

  /**
   * GET /api/configuracao-integracao/{id}/estacoes-relacionadas
   * Lista estações vinculadas à configuração de integração. Retorna existe e estacoes (id, nome).
   */
  getEstacoesRelacionadas(id: number): Observable<{ existe: boolean; estacoes: Array<{ id: number; nome: string }> }> {
    return this.http.get<any>(`${this.url_base}/${this.prefixo}/${id}/estacoes-relacionadas`);
  }
}
